// extracted by mini-css-extract-plugin
export var explainable = "_kg-a";
export var printerCard = "_kg-1";
export var printerCardConfigured = "_kg-2";
export var printerCardError = "_kg-3";
export var printerCardsContainer = "_kg-0";
export var printerIcon = "_kg-8";
export var printerIconConfigured = "_kg-5";
export var printerIconContainer = "_kg-4";
export var printerIconError = "_kg-6";
export var printerIconUnconfigured = "_kg-7";
export var workstationsTableCard = "_kg-9";